import {
  Directive,
  ElementRef,
  Input,
  AfterContentInit,
  OnDestroy
} from '@angular/core';

/**
 * Directive to set focus on an element. It will set up a timer of a given time before calling focus
 * on the element.
 *
 * The focus is applied inside the `ngAfterContentInit` hook, and the blur is applied when the input is destroyed.
 *
 * The element is not focused again, unless the directive is destroyed and created again.
 */
@Directive({
    selector: '[autoFocus]',
    standalone: false
})
export class AutoFocusDirective implements AfterContentInit, OnDestroy {
  private timerId: number | null = null;

  /**
   * Time to wait before calling focus
   */
  @Input('waitTime') private waitTime: number = 500;

  constructor(private readonly el: ElementRef<HTMLElement>) {}

  public ngAfterContentInit(): void {
    this.timerId = window.setTimeout(() => {
      this.el.nativeElement.focus();
    }, this.waitTime);
  }

  public ngOnDestroy(): void {
    /**
     * It is important to do this since the function passed to `setTimeout` can be called
     * after the component is destroyed, and it will throw an error, since `this.el` will be undefined or
     * whatnot.
     */
    if (this.timerId) {
      clearTimeout(this.timerId);
      this.timerId = null;
    }
  }
}
